export const iconFontAwesomeMusicVideoVolumeXmark = (
	<i className="fa-solid fa-volume-xmark"></i>
);
